import { render, staticRenderFns } from "./incidentReportProofStatus.vue?vue&type=template&id=23b28e7f&scoped=true"
import script from "./incidentReportProofStatus.vue?vue&type=script&lang=js"
export * from "./incidentReportProofStatus.vue?vue&type=script&lang=js"
import style0 from "./incidentReportProofStatus.vue?vue&type=style&index=0&id=23b28e7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b28e7f",
  null
  
)

export default component.exports